import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'react-google-maps';
import { Header } from 'semantic-ui-react';
class MapMarker extends Component {
    constructor(props) {
        super(props);
        this.state = {open: props.open || false}
        this.onToggleClick = this.onToggleClick.bind(this);
    }

    onToggleClick(e) {
        const {open} = this.state;
        this.setState({open: !open});
    }
    
    render() {
        const {open} = this.state;
        const {position, title, address, moreDetailsURL, icon} = this.props;
        return (
            <Marker position={position} onClick={this.onToggleClick} icon={icon}>
                {open ? <InfoWindow onCloseClick={this.onToggleClick}>
                    <div>
                        {title ? <Header as='h4' content={title} /> : null}
                        {address ? <p>{address}</p> : null}
                        {moreDetailsURL ? <a href={moreDetailsURL}>More details</a> : null}
                    </div>
                </InfoWindow> : null}
            </Marker>
        );
    }
}

MapMarker.propTypes = {
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    title: PropTypes.string,
    address: PropTypes.string,
    moreDetailsURL: PropTypes.string,
    icon: PropTypes.string,
};

export default MapMarker;